// extracted by mini-css-extract-plugin
module.exports = {"bottomMargin":"ShipFromStore_bottomMargin__4ugN_","infoList":"ShipFromStore_infoList__uxVTE"};